import { Reveal, SectionLabel } from "./Reveal";

const CHAPTERS = [
  {
    num: "01",
    title: "Two brothers. One mound.",
    body: "We grew up chasing the same thing every serious pitcher chases — more velocity, cleaner mechanics, and results that show up in games. We lived the trial-and-error, the conflicting advice, the plateaus.",
  },
  {
    num: "02",
    title: "The system we wish we'd had.",
    body: "So we built it. Fuel Factory combines movement science, motion capture, and objective tracking into a development framework that removes the guesswork and replaces it with proof.",
  },
  {
    num: "03",
    title: "Training that actually works.",
    body: "This is next-generation performance training for athletes who are done hoping and ready to know. Grounded in science, driven by data, measured in real game results.",
  },
];

export const About = () => (
  <section
    id="about"
    data-testid="about-section"
    className="relative border-t border-white/10 bg-[#050505] py-24 md:py-32"
  >
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <Reveal>
        <SectionLabel>[ About / Mission ]</SectionLabel>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className="mt-5 max-w-4xl font-heading text-4xl font-black uppercase leading-none tracking-tight text-white md:text-7xl">
          Built by pitchers,
          <br />
          <span className="text-white/40">for pitchers.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-px border-l border-t border-white/10 md:grid-cols-3">
        {CHAPTERS.map((c, i) => (
          <Reveal
            key={c.num}
            delay={i * 0.12}
            className="border-b border-r border-white/10 p-8 md:p-10"
            data-testid={`about-chapter-${i}`}
          >
            <span className="font-mono text-sm text-[#00F0FF]">/ {c.num}</span>
            <h3 className="mt-4 font-heading text-2xl font-bold uppercase tracking-tight text-white">
              {c.title}
            </h3>
            <p className="mt-4 font-body text-sm leading-relaxed text-white/55">{c.body}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default About;
